import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const PUBLIC_BASE_URL = process.env.REACT_APP_PUBLIC_BASE_URL;

export const getWithdrawalsList = createAsyncThunk(
  'withdrawal/getWithdrawalsList',
  async ({ withdrawal_request_status, skip, limit, date, status }, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
        },
        withCredentials: true,
        params: {
          ...(withdrawal_request_status ? { withdrawal_request_status } : {}),
          ...(skip ? { skip: skip - 1 } : {}),
          ...(limit ? { limit } : {}),
          ...(date ? { date } : {}),
          ...(status ? { status } : {}),
        },
      };

      const response = await axios.get(
        `${PUBLIC_BASE_URL}/withdrawal-requests`,
        config
      );
      return response.data;
    } catch (err) {
      if (err.message === 'Network Error') {
        return rejectWithValue({
          response: {
            data: {
              message: 'Network Error',
              status: err.code,
              statusText: err.code,
            },
          },
        });
      } else {
        return rejectWithValue(
          err.response?.data?.message || 'An error occurred'
        );
      }
    }
  }
);

export const updateWithdrawalStatus = createAsyncThunk(
  'withdrawal/updateWithdrawalStatus',
  async (withdrawalData, { rejectWithValue }) => {
    try {  
      const config = {
        headers: {
          'Content-Type': 'application/json',
        },
        withCredentials: true,
      };
      
      const body = JSON.stringify(withdrawalData);

      const response = await axios.put(
        `${PUBLIC_BASE_URL}/withdrawal-requests/update-withdrawal-request`,
        body,
        config
      );
      return response.data;
    } catch (err) {
      if (err.message === 'Network Error') {
        return rejectWithValue({
          message: 'Network Error',
          status: err.code,
          success: false,
        });
      } else {
        return rejectWithValue(err.response?.data || 'Unknown error occurred.');
      }
    }
  }
);

export const getWithdrawalById = createAsyncThunk(
  'withdrawal/getWithdrawalById',
  async (id, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
        },
        withCredentials: true,
      };

      const response = await axios.get(
        `${PUBLIC_BASE_URL}/withdrawal-requests/${id}`,
        config
      );
      return response.data;
    } catch (err) {
      if (err.message === 'Network Error') {
        return rejectWithValue({
          response: {
            data: {
              message: 'Network Error',
              status: err.code,
              statusText: err.code,
            },
          },
        });
      } else {
        return rejectWithValue(
          err.response?.data?.message || 'An error occurred'
        );
      }
    }
  }
);
